import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { useSpring, animated } from 'react-spring';
import style from './style.module.scss';
import Colors from '../../globalStyles/variables.json';
import LandingSliderSection from './LandingSliderSection';
import BeachBackDrop from '../../images/landing_page/beach_scene_02.png';
import EventsSection from './EventsSection';
import LearnMoreBox from './LearnMoreBox';
import BimboWaving from '../../images/products/bimbo_waving.png';
import Chef from '../../images/bimbo_slides_icons/chef.png';
import Cookies from '../../images/bimbo_slides_icons/chocolate_chip_cookies.png';
import BackPack from '../../images/bimbo_slides_icons/backpack.png';
import { LottieLoadingView } from '..';

const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]

// Various image/pointer movement algorithms. Uncomment whichever one is to be passed to the <animated.div>
const trans1 = (x, y) => `translate3d(${x / 50}px,${y / 50}px,0)`
// const trans2 = (x, y) => `translate3d(${x / 8 + 35}px,${y / 8 - 230}px,0)`
// const trans3 = (x, y) => `translate3d(${x / 6 - 250}px,${y / 6 - 200}px,0)`
// const trans4 = (x, y) => `translate3d(${x / 3.5}px,${y / 3.5}px,0)`

const Landing = (props) => {

  const [haveImagesLoaded, setHaveImagesLoaded] = useState(false);

  useEffect(() => {
    var beachImage = new Image;
    beachImage.onload = () => setHaveImagesLoaded(true);
    beachImage.src = BeachBackDrop;
  }, []);

  return (
    <div className={style.landingWrapper}>
      <div className={style.contentWrapper}>
        {haveImagesLoaded ? <Carousel
          className={style.carousel}
          showThumbs={false}
          showArrows={false}
          infiniteLoop={true}
          autoPlay={false}
          stopOnHover={false}
          showStatus={false}
          interval={4000}
        >
          <div>
            <LandingSliderSection />
          </div>
          <div>
            <LearnMoreBox
              title={<span>Delicious<br />Recipes</span>}
              backgroundColor={Colors.$red}
              image={Chef}
              imagePosition="right"
              learnMoreLink="/recipes"
              containerClassName={style.learnMoreOverride}
              imageClassName={style.learnMoreImageOverride}
            />
          </div>
        </Carousel> : <LottieLoadingView />}
        <section className={style.learnMoreSection}>
          <LearnMoreBox
            title={<span>Delicious<br />Recipes</span>}
            backgroundColor={Colors.$red}
            image={Chef}
            learnMoreLink="/recipes"
          />
          <LearnMoreBox
            title={<span>Bimbo Goes<br />to School</span>}
            backgroundColor={Colors.$yellow}
            image={BackPack}
            imagePosition="left"
            learnMoreLink="/school-program" />
          <LearnMoreBox
            title={<span>New<br />Products</span>}
            backgroundColor={Colors.$orange}
            image={Cookies}
            learnMoreLink="/products" />
          <LearnMoreBox
            title={<span>Meet<br />Bimbo</span>}
            backgroundColor={Colors.$lightBlue}
            image={BimboWaving}
            learnMoreLink="/meet-bimbo"
            imagePosition="left" />
        </section>
        <EventsSection />
      </div>
    </div>
  )
};

export default Landing;
